import { render, staticRenderFns } from "./left-bottom.vue?vue&type=template&id=f063d030&scoped=true"
import script from "./left-bottom.vue?vue&type=script&lang=js"
export * from "./left-bottom.vue?vue&type=script&lang=js"
import style0 from "./left-bottom.vue?vue&type=style&index=0&id=f063d030&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f063d030",
  null
  
)

export default component.exports